
import React from 'react';
import { LogOut, User as UserIcon } from 'lucide-react';
import { User } from '../types';

interface NavbarProps {
  user: User;
  onLogout: () => void;
}

const Navbar: React.FC<NavbarProps> = ({ user, onLogout }) => {
  return (
    <nav className="bg-white border-b border-slate-200 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16 items-center">
          <div className="flex items-center gap-3">
            <div className="relative group cursor-pointer">
              {/* Subtle glow effect behind the logo */}
              <div className="absolute -inset-0.5 bg-gradient-to-r from-indigo-500 to-purple-500 rounded-xl blur opacity-25 group-hover:opacity-50 transition duration-300"></div>
              
              <div className="relative h-10 w-10 rounded-xl overflow-hidden border border-slate-200 shadow-sm bg-white flex items-center justify-center">
                <img 
                  src="https://images.unsplash.com/photo-1614850523296-d8c1af93d400?w=128&h=128&fit=crop&q=80" 
                  alt="WordCast Logo"
                  className="h-full w-full object-cover"
                />
              </div>
            </div>
            <span className="text-xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-indigo-600 to-purple-600 tracking-tight">
              WordCast
            </span>
          </div>
          
          <div className="flex items-center gap-4">
            {user.isLoggedIn ? (
              <div className="flex items-center gap-4">
                <div className="hidden sm:flex items-center gap-2 text-slate-600 bg-slate-100 px-3 py-1 rounded-full text-sm">
                  <UserIcon size={16} />
                  <span>{user.email}</span>
                </div>
                <button
                  onClick={onLogout}
                  className="flex items-center gap-2 text-slate-500 hover:text-red-600 transition-colors text-sm font-medium"
                >
                  <LogOut size={18} />
                  <span className="hidden sm:inline">Logout</span>
                </button>
              </div>
            ) : (
              <span className="text-sm text-slate-500 italic hidden sm:block">Simplifying content creation</span>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
